import { required } from "vee-validate/dist/rules";

export default {
  es: {
    register_card: "Registrar tarjeta de crédito",
    welcome: "Bienvenido(a),",
    informationPersonal: "Información personal",
    identification: "Identificación",
    contact_information: "Información de Contacto",
    payment_information: "Información de tarjeta",
    updateInformation: "Completar información",
    updateInformationDescription: "Tu información está protegida mediante cifrado seguro.",
    // registerCard: "Registrar tarjeta",
    // registerPayment: "Registrar pago de forma segura",
    // encryptedMessage: "Tus datos están protegidos y encriptados",
    // enterCardDetails: "Ingresa los detalles de tu tarjeta de crédito o débito para realizar el pago.",
    // card: "Tarjeta",
    // name: "Nombre del cliente",
    cardholder: "Nombre tal como aparece en la tarjeta",
    first_name: "Primer Nombre",
    last_name: "Apellidos",
    middle_name: "Segundo nombre",
    aptunitspc: "APT / Unit / SPC",
    identification_type: "Tipo de Identificación",
    identification_number: {
      ssn: "Número de SSN",
      itin: "Número de ITIN",
      others: "Otros"
    },
    dob: "Fecha de nacimiento",
    email: "Email",
    cardNumber: "Número de tarjeta",
    expiryDate: "Fecha de expiración",
    cvv: "Código de seguridad",
    optional: "(opcional)",
    billingAddress: "¿Es la dirección de facturación la misma que su dirección personal?",
    yes: "Si",
    no: "No",
    requiredFields: "Campos obligatorios",
    // month: "Mes",
    // year: "Año",
    placeholder: {
      cardholder: "Nombre completo como aparece en la tarjeta",
      cardNumber: "0000 0000 0000 0000",
      cvv: "CVV",
      first_name: "Ingrese su nombre",
      last_name: "Ingrese su apellido",
      identification_number: {
        ssn: "XXX-XX-XXXX",
        itin: "9XX-XX-XXXX",
        others: "Ingrese su número de identificación"
      },
      dob: "MM/DD/AAAA",
      email: "Ingrese su correo electrónico",
      address: "Ingrese su dirección",
      middle_name: "Ingrese su segundo nombre",
      city: "Ingrese su ciudad",
      state: "Ingrese su estado",
      zipcode: "Ingrese su código postal",
    },
    alt: {
      cardImage: "Imagen de la tarjeta",
    },
    button: {
      save: "Guardar",
    },
    // termsAndConditions: "Términos y condiciones",
    // privacyPolicy: "Política de privacidad",
    // secure: "Conexión segura",
    // detail: {
    //     title: "Detalles del pago",
    // },
    // concept: "Concepto",
    // subconcept: "Subconcepto",
    validation: {
      "mustBeAtLeast": "debe tener al menos",
      "charactersLong": "caracteres",
      "mustNotExceed": "no debe exceder",
      characters: "caracteres",
      required: "es requerido",
      onlyLetters: "solo puede contener letras y espacios",
      // min: "mínimo",
      mustBeNumeric: "debe ser numérico",
      invalidEmail: "debe ser un correo electrónico válido",
      invalidExpirationDate: "Fecha de expiración inválida",
      digits: "dígitos"
    },
    // totalAmount: "Monto total",
    // client: "Cliente",
    // clientName: "Nombre",
    // clientLastName: "Apellido",
    tooltip: {
      cvv: "CVV es el código de 3 dígitos <br /> que se encuentra en la <br /> parte posterior de tu tarjeta.",
      expiryDate: "La fecha de expiración se <br /> encuentra típicamente en la <br /> parte frontal de tu tarjeta, debajo <br /> del número de tarjeta.",
    },
    // successMessages: {
    //     success: "Éxito",
    //     cardRegistered: "Tarjeta registrada exitosamente",
    //     completedForm: "Tu pago ha sido procesado con éxito. Puedes cerrar esta ventana.",
    //     paymentSuccess: "Pago exitoso",
    // },
    errorMessages: {
      error: "Error",
      // genericError: "Ocurrió un error, por favor intenta nuevamente.",
      // cardNotRegistered: "No se pudo registrar la tarjeta",
      // cardInvalid: "Tarjeta inválida",
      // linkInvalid: "Enlace inválido",
      // cardNotVerified: "No se pudo verificar la tarjeta",
      // cardAlreadyRegistered: "La tarjeta ya ha sido registrada",
    },
    invalidLink: "Enlace inválido",
    invalidLinkDescription: "El enlace que buscas ha expirado o ya no está disponible.",
    validLink: "Gracias por completar su información.",
    validLinkDescription: ", ahora sus datos están actualizados. Puedes cerrar esta ventana.",
    validLinkDescriptionWithErrors: "La operación se ha completado con errores. Puedes cerrar esta ventana.",
    // initialPayment: "Pago inicial",
    // transactionDeclined: "Transacción declinada",
    // automaticPayment: "Pago automático",
    // automaticPaymentDate: "Fecha de pago",
    // amount: "Monto",
    // status: "Estado",
    // service: "Servicio",
    // concept: "Concepto",
    // datetime: "Fecha/Hora",
    // transactionId: "ID Transacción",
    identification_type_options: [
      { value: "ssn", text: "Número de Seguro Social (SSN)" },
      { value: "itin", text: "Número de Identificación Personal del Contribuyente (ITIN)" },
      { value: "others", text: "Otra Identificación" }
    ],
    address: "Dirección",
    city: "Ciudad",
    state: "Estado",
    zipcode: "Código Postal",
    Enero: "Enero",
    Febrero: "Febrero",
    Marzo: "Marzo",
    Abril: "Abril",
    Mayo: "Mayo",
    Junio: "Junio",
    Julio: "Julio",
    Agosto: "Agosto",
    Septiembre: "Septiembre",
    Octubre: "Octubre",
    Noviembre: "Noviembre",
    Diciembre: "Diciembre",
    Month: "Mes",
    Day: "Dia",
    Year: "Año",
  },
  en: {
    register_card: "Register credit card",
    welcome: "Welcome,",
    informationPersonal: "Personal information",
    identification: "Identification",
    contact_information: "Contact Information",
    payment_information: "Card information",
    updateInformation: "Complete information",
    updateInformationDescription: "Your information is protected by secure encryption.",
    // registerCard: "Register card",
    // registerPayment: "Register payment securely",
    // encryptedMessage: "Your data is protected and encrypted.",
    // enterCardDetails: "Enter your credit or debit card details to make the payment.",
    // card: "Card",
    // name: "Client name",
    cardholder: "Name as it appears on the card",
    first_name: "First name",
    last_name: "Last name",
    middle_name: "Middle name",
    identification_type: "Identification Type",
    billingAddress: "Is the billing address the same as your personal address?",
    yes: "Yes",
    no: "No",
    requiredFields: "Required fields",
    identification_number: {
      ssn: "SSN Number",
      itin: "ITIN Number",
      others: "Others"
    },
    dob: "Date of birth",
    email: "Email",
    cardNumber: "Card number",
    expiryDate: "Expiration date",
    cvv: "Security code",
    optional: "(optional)",
    aptunitspc: "APT / Unit / SPC",
    // month: "Month",
    // year: "Year",
    placeholder: {
      cardholder: "Full name as it appears on the card",
      cardNumber: "0000 0000 0000 0000",
      cvv: "CVV",
      first_name: "Enter your first name",
      last_name: "Enter your last name",
      identification_number: {
        ssn: "XXX-XX-XXXX",
        itin: "9XX-XX-XXXX",
        others: "Enter your ID number"
      },
      dob: "MM/DD/YYYY",
      email: "Enter your email",
      address: "Enter your address",
      middle_name: "Enter your middle name",
    },
    alt: {
      cardImage: "Card image",
    },
    button: {
      save: "Save",
    },
    // termsAndConditions: "Terms and conditions",
    // privacyPolicy: "Privacy policy",
    // secure: "Secure connection",
    // detail: {
    //     title: "Payment details",
    // },
    // concept: "Concept",
    // subconcept: "Subconcept",

    validation: {
      mustBeAtLeast: "must be at least",
      charactersLong: "characters long",
      mustNotExceed: "must not exceed",
      characters: "characters",
      required: "is required",
      onlyLetters: "can only contain letters and spaces",
      // min: "min",
      mustBeNumeric: "must be numeric",
      invalidEmail: "must be a valid email",
      invalidExpirationDate: "Invalid expiration date",
      digits: "digits"
    },
    // totalAmount: "Total amount",
    // client: "Client",
    // clientName: "Name",
    // clientLastName: "Last name",
    tooltip: {
      cvv: "CVV is the 3-digit code <br /> found on the <br /> back of your card.",
      expiryDate: "The expiration date is <br /> typically located on the <br /> front of your card, below <br /> the card number.",
    },
    // successMessages: {
    //     success: "Success",
    //     cardRegistered: "Card registered successfully",
    //     completedForm: "Your payment has been successfully processed. You can close this window.",
    //     paymentSuccess: "Payment successful",
    // },
    errorMessages: {
      error: "Error",
      // genericError: "An error occurred, please try again.",
      // cardNotRegistered: "Card not registered",
      // cardInvalid: "Invalid card",
      // linkInvalid: "Invalid link",
      // cardNotVerified: "Card could not be verified",
      // cardAlreadyRegistered: "Card already registered",
    },
    invalidLink: "Invalid link",
    invalidLinkDescription: "The link you are looking for has expired or is no longer available.",
    validLink: "Thank you for completing your information",
    validLinkDescription: ", now your data is updated. You can close this window.",
    validLinkDescriptionWithErrors: "The operation has been completed with errors. You can close this window.",
    // initialPayment: "Initial payment",
    // transactionDeclined: "Transaction declined",
    // automaticPayment: "Automatic payment",
    // automaticPaymentDate: "Payment date",
    // amount: "Amount",
    // status: "Status",
    // service: "Service",
    // concept: "Concept",
    // datetime: "Date/Time",
    // transactionId: "Transaction ID",
    identification_type_options: [
      { value: "ssn", text: "Social Security Number (SSN)" },
      { value: "itin", text: "Individual Taxpayer Identification Number (ITIN)" },
      { value: "others", text: "Other Identification" }
    ],
    address: "Address",
    city: "City",
    state: "State",
    zipcode: "Zip Code",
    Enero: "January",
    Febrero: "February",
    Marzo: "March",
    Abril: "April",
    Mayo: "May",
    Junio: "June",
    Julio: "July",
    Agosto: "August",
    Septiembre: "September",
    Octubre: "October",
    Noviembre: "November",
    Diciembre: "December",
    Month: "Month",
    Day: "Day",
    Year: "Year",
  },
};
